import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/style.css";
import "./styles/themes.css";
import "./styles/theme-fonts.css";

import { registerBuiltinLessons } from "./lessons/builtin";
import { registerApCspLessons } from "./lessons/apcsp";
import { registerCustomLessons } from "./lessons/custom";
import { App } from "./app/App";
import { useProgressStore } from "./app/stores/progressStore";
import { syncThemeFromStore } from "./app/theme/applyTheme";

// Register lesson content before the app reads the registry.
registerBuiltinLessons();
registerApCspLessons();
registerCustomLessons();
useProgressStore.getState().init();

// Apply the persisted theme before the first render so the initial canvas
// paint already uses the right palette.
syncThemeFromStore();

const container = document.getElementById("learnBody");
if (!container) throw new Error("Missing #learnBody root element");

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
